module.exports = __webpack_public_path__ + "media/components/icons/SVG/analysis-ecc13983c1415f19a8222c86303d4575.svg";